import {
  Account,
  Id,
  Identifiable,
  Resource,
  CalendarHolidays,
  calendarHolidays,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedPlanzoneResource, Linker } from "../linkers/types";

type Response = {
  _embedded: {
    resources: (LinkedPlanzoneResource & { userUuid: Id })[];
  };
};

function getUserHumanResource(httpClient: HttpClient, linker: Linker) {
  return ({ uuid }: Identifiable<Account>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/resources/search/rsql?query=userContext.userUuid=="${uuid}"`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded: { resources } }) =>
        resources[0] ? resources[0] : Promise.reject(),
      )
      .then((resource) =>
        httpClient
          .sendHttpRequest<Identifiable<CalendarHolidays>>({
            endpoint: `/resources/${resource.uuid}/calendarHolidays`,
            method: HttpMethods.GET,
          })
          .then(
            (calendarHolidays) => ({
              ...resource,
              calendarHolidays,
            }),
            () => ({
              ...resource,
              calendarHolidays: calendarHolidays,
            }),
          ),
      )
      .then(linker.linkResource);
}

export { getUserHumanResource };
